export const nameValidate = /^\p{L}+(?: \p{L}+)*$/u;
export const emailValidate = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
export const phoneValidate = /^\+?\d{7,15}$/